export const WarrantyClaimStatus = {
    DRAFT: 10,               // taslak
    WAITING: 20,             // onaya gönderildi
    RETURNED: 15,            // bayiye iade
    RETURNED_TO_KARSAN: 25,  // karsan'a iade
    ACCEPTED: 30,            // onaylandı
    REJECTED: 40             // red
};
